import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";

export const updateQuoteStatus = (payload: { id_quote: number; status_quote: string }) => {
   return apiClient<ApiResponse>("/v1/quote/status", {
      method: "PUT",
      body: payload
   })
}
